<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <div class="pd-10 bg-white">
      <!-- 返回按钮 -->
      <div
        class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
        @click="$router.push('/communication/communicationSet')"
      >
        <i class="el-icon-arrow-left fw-600"></i>
        返回
      </div>

      <el-descriptions border title="订单详情" class="mgt-20" :column="1">
        <el-descriptions-item label="套餐名称">
          <span
            v-text="
              dataInfo.packageType == 1 ? '短信充值套餐' : '语音电话充值套餐'
            "
          ></span>
        </el-descriptions-item>
        <el-descriptions-item label="套餐条数">{{
          dataInfo.num
        }}</el-descriptions-item>
        <el-descriptions-item label="每条价格">{{
          dataInfo.unitPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="套餐金额">{{
          dataInfo.payPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="有效时长">
          <span
            v-text="
              dataInfo.validityMoth
                ? dataInfo.validityMoth + '个月'
                : '永久有效'
            "
          ></span>
        </el-descriptions-item>
        <el-descriptions-item label="订单编号">{{
          orderNo
        }}</el-descriptions-item>
        <el-descriptions-item label="订单生成时间">{{
          createTime
        }}</el-descriptions-item>
      </el-descriptions>
      <!-- === -->
      <el-descriptions border title="支付方式" class="mgt-20" :column="1">
        <el-descriptions-item label="需付金额" v-if="orderState == '待支付'">
          {{ dataInfo.payPrice }}
        </el-descriptions-item>
        <el-descriptions-item label="支付金额" v-if="orderState !== '待支付'">
          {{ dataInfo.payPrice }}
        </el-descriptions-item>
        <el-descriptions-item label="支付时间" v-if="orderState !== '待支付'">
          {{ payTime }}
        </el-descriptions-item>
        <el-descriptions-item label="订单状态">{{
          orderState
        }}</el-descriptions-item>
        <el-descriptions-item label="支付二维码" v-if="orderState == '待支付'">
          <img :src="codeImg" alt="" />
        </el-descriptions-item>
      </el-descriptions>
      <div class="flex jcc mgt-20" v-if="orderState !== '待支付'">
        <el-button @click="$router.push('/communication/communicationSet')"
          >已 知 晓</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      dataInfo: null,
      orderNo: null,
      createTime: null,
      orderState: "待支付",
      codeImg: null,
      timer: null,
      payTime: null,
    };
  },
  created() {
    this.dataInfo = this.$route.query.data;
    this.getOrderPay();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getOrderPay() {
      this.$api.communication
        .setPay({ packageId: this.$route.query.data.id, payType: 5 })
        .then((res) => {
          if (res.code === 200) {
            this.orderNo = res.data.orderNo;
            this.codeImg = res.data.img;
            this.do();
          }
        });
    },

    getOrder() {
      this.$api.communication
        .orderNoTime({ orderNo: this.orderNo })
        .then((d) => {
          if (d.code === 200) {
            this.createTime = d.data.createTime;
            this.payTime = d.data.payTime;
            this.orderState =
              d.data.state == 1
                ? "待支付"
                : d.data.state == 2
                ? "已支付"
                : "已到账";
          }
        });
    },
    do() {
      this.getOrder();
      if (this.orderState === "待支付") {
        this.timer = setTimeout(() => {
          this.do();
        }, 10000);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
